<template>
    <div v-if="content.length > 0">
        <div class="text-left d-center-between" :class="orderId ? 'h5' : 'h2'">
            <span>{{title}}</span>
        </div>
        <ul class="list-head mt-1 text-center" >
            <li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li>
        </ul>
        <div class="d-flex align-items-center border-bottom" v-for="(item,index) in content" :key="index">
            <div class="flex1" v-if="item.arr.length > 0">
                <span v-if="orderId">{{item.time | formatTimestamp}}</span>
                <span v-else>{{item.usetime}}</span>
            </div>
            <div :class="(orderId && userInfo.type == 2) ? 'flex3' : 'flex2'">
                <ul v-for="(v,i) in item.arr" :key="i" class="list-item">
                    <li class="w-50 list-item-col-end">
                        <div v-if="orderId">
                            <label>{{v.name}}</label>
                            <label class="text-dark" v-if="type == 'meet'">({{v.timeslot | formatVar('BTimeSlots')}})</label>
                            <label class="text-dark" v-if="type == 'restaurant'">({{v.timeslot | formatVar('EateryTime')}})</label>
                        </div>
                        <div v-else>
                            <div v-if="type == 'room'">{{v.title}} - {{v.type | formatVar('brandroomStyle')}}</div>
                            <div v-if="type == 'meet'">
                                {{v.type | formatVar('LayoutTypes')}} - {{v.retime | formatVar('BPTimeSlots')}}
                            </div>
                            <div v-if="type == 'restaurant'">
                                {{v.tag | formatVar('BMealType')}}-{{v.name}} - {{v.eatime | formatVar('EateryTime')}}
                            </div>
                            <div v-if="type == 'acti'">{{v.species | formatVar('ticketTypeArr')}}-{{v.name}}</div>
                            <div v-if="type == 'itinerary'">{{v.name}}</div>
                        </div>
                    </li>
                    <li class="w-50 list-item-col-end">&yen;{{v.price}}<li>
                    <li class="w-50 list-item-col-end flex-column">
                        <div v-if="orderId">{{v.num}}</div>
                        <div v-else>
                            <div v-if="type == 'meet'">1</div>
                            <div v-else>
                                <div class="d-flex align-items-center justify-content-center mt-1">
                                    <i class="iconfont text-blue cursor-pointer" style="font-size: 16px;" @click="minusNum(v,i)">&#xe6f2;</i>
                                    <input type="number" class="product-num" v-model.number="v.num">
                                    <i class="iconfont text-blue cursor-pointer" style="font-size: 18px;" @click="addNum(v,i)">&#xe613;</i>
                                </div>
                                <div class="text-muted mt-2 mr-2 h6" v-if="type == 'room'">（最大可供房：{{v.totalNum}}间）</div>
                                <div class="text-muted mt-2 mr-2 h6" v-if="type == 'restaurant' && v.type == 2">（最少{{v.minNum}}人起）</div>
                            </div>
                        </div>
                    </li>
                    <li class="w-50 list-item-col-end text-info">
                        &yen;<span v-if="type == 'meet'">{{v.price}}</span><span v-else>{{Number(v.price) * v.num}}</span>
                    </li>
                    <li class="w-50 list-item-col-end" v-if="orderId && userInfo.type != 2">
                        <label class="text-link" v-if="canEdit">
                            <span class="h6 mr-2" v-if="brand || isAdmin" @click="edit(v)">编辑</span>
                            <span @click="delItem(v,i,index)">删除</span>
                        </label>
                        <label class="text-muted" v-else>不可操作</label>
                    </li>
                    <li class="w-50 list-item-col-end text-link" v-if="$route.path.includes('shop_car')">
                        <span @click="delItem(v,i,index)">删除</span>
                    </li>
                </ul>
            </div>
        </div>
        <el-dialog title="编辑" :visible.sync="showEdit" center width="900px">
            <ul class="list-head mt-3 text-center">
                <li class="w-50" v-for="item in headArr" :key="item">{{item}}</li>
            </ul>
            <ul class="list-item">
                <li class="w-50 list-item-col-end">
                    <div v-if="brand">
                        <span>{{cardItem.time | formatTimestamp}}</span>
                        <span v-if="cardItem.type == 2">{{cardItem.timeslot | formatVar('BTimeSlots')}}</span>
                        <span v-if="cardItem.type == 3">{{cardItem.timeslot | formatVar('EateryTime')}}</span>
                    </div>
                    <div v-if="isAdmin">
                        <el-date-picker class="w-80" size="small" v-model="cardItem.time" type="date" placeholder="选择日期" />
                        <el-select class="w-80 mt-2" v-if="cardItem.type == 2" v-model="cardItem.timeslot" placeholder="请选择" size="small">
                            <el-option v-for="item in $GVAR.BTimeSlots" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                        <el-select class="w-80 mt-2" v-if="cardItem.type == 3" v-model="cardItem.timeslot" placeholder="请选择" size="small">
                            <el-option v-for="item in $GVAR.EateryTime" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </div>
                </li>
                <li class="w-50 list-item-col-end">{{cardItem.name}}</li>
                <li class="w-50 list-item-col-end">
                    <el-input class="w-70" size="small" type="number" v-model="cardItem.price">
                        <template slot="append">元</template>
                    </el-input>
                </li>
                <li class="w-50 list-item-col-end">
                    <el-input-number size="small" :min="1" v-model="cardItem.num" />
                </li>
                <li class="w-50 list-item-col-end text-info">&yen;{{Number(cardItem.price) * cardItem.num}}</li>
            </ul>
            <div slot="footer" class="mt-2">
                <el-button @click="showEdit = false">取 消</el-button>
                <el-button class="ml-5" type="primary" @click="editItem">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapState,mapGetters,mapActions} from 'vuex'
export default {
    name: 'BrandOrder',
    props:['content','type'],
    data () {
        return {
            showEdit: false,
            cardItem: {},
            headArr: ['使用日期','项目名称','单价','数量','小计'],
        }
    },
    watch: {
        content:{ 
            handler(val, oldVal){ this.getAllPrice() }, 
            deep:true
        }
    },
    computed: {
        ...mapState(['OrderDetail']),
        ...mapGetters(['brand','isAdmin','userInfo']),
        title () {
            switch (this.type) {
                case 'room':
                    return '客房';break;
                case 'meet':
                    return '会议室';break;
                case 'restaurant':
                    return '餐饮';break;
                case 'acti':
                    return '活动';break;
                case 'itinerary':
                    return '线路行程';break
                default:
                    break;
            }
        },
        orderId () { return this.$route.query.orderId },
        titleArr () {
            let arr = ['使用日期','类型','价格','数量','小计','操作'];
            if (this.userInfo.type == 2 && this.orderId) arr.pop()
            return arr
        },
        canEdit () {
            if (Number(this.OrderDetail.original_price) > 0) return false
            else return true
        }
    },
    methods: {
        ...mapActions(['editDelBrandOrder']),
        addNum(item, index) {
            if (item.num + 1 > item.totalNum) {
                this.$alert('请勿超过最大数量', '提示', {
                    confirmButtonText: '确定',
                    center: true
                });
            } else item.num++;
        },
        minusNum(item, index) {
            if (item.num - 1 <= 0 || item.num < (item.minNum+1)) {
                this.$alert('数值有误', '提示', {
                    confirmButtonText: '确定',
                    center: true
                });
            } else item.num--;
        },
        getAllPrice() {
            let rp = 0
            this.content.forEach(v => v.arr.forEach(m => rp+=(Number(m.price) * (m.num || 1))))
            this.$emit('getPrice',rp,this.type)
        },
        edit(v) {
            this.showEdit = true;
            if (this.isAdmin) {
                this.cardItem = {...v,time: v.time * 1000}
                if (v.type == 3) this.cardItem.timeslot = String(this.cardItem.timeslot)
            } else this.cardItem = v
        },
        editItem() {
            if (!this.$GFUN.isFloatInteger(this.cardItem.price)) { this.$message.warning('您的金额输入有误'); return }
            if (this.isAdmin && !this.cardItem.time) { this.$message.warning('请选择使用日期'); return }
            this._confirm('确认编辑该项么？',() => {
                let data = {
                    order_brandhall_id: this.cardItem.id,price: this.cardItem.price,num: this.cardItem.num,
                }
                if (this.isAdmin) {
                    data.time = new Date(this.cardItem.time).getTime() / 1000;
                    data.timeslot = this.cardItem.timeslot
                }
                this.editDelBrandOrder({
                    data,
                    flag: 1,
                    successFun: _ => this.showEdit = false
                })
            })
        },
        delItem (item,i,index) {
            if (this.brand || this.isAdmin) {
                this._confirm('确认删除该项么？',() => {
                    this.editDelBrandOrder({
                        data: {order_brandhall_id: item.id}, flag: 0,
                        successFun: _ => this.showEdit = false
                    })
                })
            } else {
                this._confirm('确认删除该项么？',() => {
                    this.content[index].arr.splice(i,1)
                    let arr = []
                    this.content.forEach(ele => arr = arr.concat(ele.arr));
                    localStorage.setItem(this.type,JSON.stringify(arr))
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.list-head{
    background-color: #fcfcfc;
    color: #5e5e5e;
    border-bottom: 0;
    font-weight: normal
}
.d-flex{
    display: flex;
    .flex1{
        flex: 1;
        text-align: center;
    }
    .flex2{
        flex: 5
    }
    .flex3{
        flex: 4
    }
    .list-item:last-child{
        border-bottom: none
    }
}
.h2,.h5{
    margin-top: 20px
}
</style>